import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared/shared.service';
import { Router } from '@angular/router';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.css']
})
export class SessionComponent implements OnInit {
  AcademicSessionList={};
  AcademicSelectionList:any;
  AcademicSelectionModel = {
    AcademicSession: 0,
    StartDate: '',
    EndDate: ''
}
  constructor(private sharedService:SharedService,private router:Router,private globalHelper :GlobalHelper) {
    
  }
  

        SetAcademicSession(item) {
             this.sharedService.SetAcademicSession(JSON.stringify(item)).subscribe((data:any)=>{             
              this.globalHelper.SetSessionTemplate(data.Template);               
                this.router.navigate(['/dashboard']);
            });

        };

       

        GetAllAcademicSelection () {
       
            this.sharedService.GetAllAcademicSelection().subscribe((data:any)=>{      
                this.AcademicSelectionList = data.AcademicSelectionList;
                
              
            })
        }



        

  ngOnInit() {
    this.GetAllAcademicSelection();
  }

}
